import { EMPTY_LIST } from '../../../constants/common'

export const USER_EDIT_CATEGORIES_MODAL_QA_NAME = 'editStaffMemberCategories'

export const USER_EDIT_CATEGORIES_MODAL_FIELD_NAME_CATEGORIES = 'categories'

export const USER_EDIT_CATEGORIES_MODAL_EMPTY_VALUES = {
  [USER_EDIT_CATEGORIES_MODAL_FIELD_NAME_CATEGORIES]: EMPTY_LIST,
}
